export function stripEn (content) {
  let newContent = {}
  for (const key in content) {
    if (content.hasOwnProperty(key)) {
      const element = content[key];
      newContent[key] = element['en-US'] || element      
    }
  }
  return newContent
}